import * as Sentry from "@sentry/react";

import appConfig from "./app";

// Keep Sentry requests same-origin so ad blockers do not block them.
// This path is intentionally fixed and is proxied to Sentry by Cloudflare in deployed envs and by Vite in dev.
const SENTRY_TUNNEL_PATH = "/tun/stry";

export const initSentryWebApp = () =>
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: SENTRY_TUNNEL_PATH,
    ...(appConfig.BUILD_HASH && {
      release: appConfig.BUILD_HASH,
      integrations: [Sentry.browserTracingIntegration()],
    }),
    ...(appConfig.IS_TEST_ENVS && { environment: "test-envs" }),
    // SEN-4913: browser plugins (SafeLinks, Clarity) inject JS that generates spurious promise rejections
    // SEN-4422: Axios ECONNABORTED on navigation — 100% vendor stack, not actionable
    // SEN-4892: stream-chat async ops resolving after client.disconnect() — vendor stack, not actionable
    ignoreErrors: [
      "Non-Error promise rejection captured with value: [Screeb]",
      /^Request aborted$/,
      /Object Not Found Matching Id/,
      /You can't use a channel after client\.disconnect\(\) was called/,
    ],
    tracesSampleRate: 0.2,
  });

export const initSentryWebworker = () =>
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: SENTRY_TUNNEL_PATH,
    ...(appConfig.BUILD_HASH && { release: appConfig.BUILD_HASH }),
  });

export const initSentryServiceWorker = () =>
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: SENTRY_TUNNEL_PATH,
    ...(appConfig.BUILD_HASH && { release: appConfig.BUILD_HASH }),
    ...(appConfig.IS_TEST_ENVS && { environment: "test-envs" }),
    // SEN-4978/SEN-4979: workbox CacheFirst 'no-response' on stale chunks post-deploy — vendor noise, UX self-recovers via reload
    ignoreErrors: [/^no-response: no-response/],
  });
